
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const AgoriFort=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Agori Fort</h1>
           <p className="sub-heading">A historic marvel by the Son River, where warriors of sonbhadra and hidden treasures come alive</p>
         </div>
         <div className="description">
         Situated near Chopan in Sonbhadra, Uttar Pradesh, Agori Fort is a testament to ancient Indian heritage and folklore. Surrounded by the Bijul, Rihand, and Son Rivers, this mysterious fort once ruled by the Kharwar and Chandel dynasties offers breathtaking views and intriguing tales of bravery, including the epic battle of Veer Lorik. Visitors can explore its ochre hills, the legendary "Kramamel Elephant" rock, and rumored underground passages brimming with treasures. Perfect for history buffs and nature lovers, Agori Fort is an enchanting destination for a serene picnic amidst its forested landscape. </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Agori Fort/fort1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Agori Fort/fort2.jpeg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Agori Fort/fort3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Agori Fort/fort4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Agori Fort/fort5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Agori Fort/fort6.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Agori Fort/fort7.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
         </div>
   
         <BookSection />
       </div>
     );
};